// @view/invite/InviteAcceptBodyReady.view.tsx

import React from "react";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { InviteAcceptViewProps } from "@ps-bridge/contracts/inviteAccept";
import * as styles from "@styles/InviteAccept.css";

type InviteAcceptBodyReadyViewProps = Pick<
  InviteAcceptViewProps,
  | "password"
  | "confirmPassword"
  | "firstName"
  | "lastName"
  | "onPasswordChange"
  | "onConfirmPasswordChange"
  | "onFirstNameChange"
  | "onLastNameChange"
  | "onSubmit"
>;

const InviteAcceptBodyReadyView: React.FC<InviteAcceptBodyReadyViewProps> = ({
  password,
  confirmPassword,
  firstName,
  lastName,
  onPasswordChange,
  onConfirmPasswordChange,
  onFirstNameChange,
  onLastNameChange,
  onSubmit,
}) => {
  return (
    <div className={styles.form}>
      <label className={styles.field}>
        <span>Password</span>
        <input
          data-testid="invite-accept-password"
          type="password"
          value={password}
          onChange={(event) => IO.run(onPasswordChange(event.target.value))}
        />
      </label>
      <label className={styles.field}>
        <span>Confirm password</span>
        <input
          data-testid="invite-accept-confirm-password"
          type="password"
          value={confirmPassword}
          onChange={(event) => IO.run(onConfirmPasswordChange(event.target.value))}
        />
      </label>
      <div className={styles.nameRow}>
        <label className={styles.field}>
          <span>First name (optional)</span>
          <input
            data-testid="invite-accept-first-name"
            type="text"
            value={firstName}
            onChange={(event) => IO.run(onFirstNameChange(event.target.value))}
          />
        </label>
        <label className={styles.field}>
          <span>Last name (optional)</span>
          <input
            data-testid="invite-accept-last-name"
            type="text"
            value={lastName}
            onChange={(event) => IO.run(onLastNameChange(event.target.value))}
          />
        </label>
      </div>
      <button
        className={styles.primaryButton}
        data-testid="invite-accept-submit"
        onClick={() => {
          IO.run(onSubmit(ok));
        }}
      >
        Activate account
      </button>
    </div>
  );
};

export default InviteAcceptBodyReadyView;
